import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Gallery from '../components/Gallery';

const ProjectDetail = () => {
  const { id } = useParams();
  const { language, t, projects } = useLanguage();

  const project = projects[id];

  if (!project) {
    return (
      <div className="wrap not-found">
        <h1 className="detail-title">Project Not Found</h1>
        <p className="prose">The project you're looking for doesn't exist.</p>
        <Link to="/projects" className="btn btn-primary">
          {t('backToProjects')}
        </Link>
      </div>
    );
  }

  const typeLabel = project.type === 'Work' ? t('workProjects') : t('schoolProjects');
  const images = Array.isArray(project.images) ? project.images : [project.image];

  return (
    <>
      <section className="detail-head">
        <div className="wrap">
          <Link to="/projects" className="back-link">
            {t('backToProjects')}
          </Link>
          <h1 className="detail-title">{project.title}</h1>
        </div>
      </section>

      <section className="section">
        <div className="wrap split">
          <dl className="meta-list split__label">
            <div>
              <dt>{typeLabel}</dt>
              <dd>{project.technologies.join(', ')}</dd>
            </div>
            {project.link && (
              <div>
                <dd>
                  <a href={project.link} target="_blank" rel="noopener noreferrer">
                    {language === 'en' ? 'View live site' : 'Voir le site'}
                  </a>
                </dd>
              </div>
            )}
          </dl>
          <div className="split__body">
            <p className="lede">{project.description}</p>
          </div>
        </div>

        <div className="wrap">
          <figure className="detail-main-image">
            <img src={project.image} alt={project.title} />
          </figure>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <Gallery images={images} alt={project.title} />
        </div>
      </section>

      <section className="section">
        <div className="wrap split">
          <h2 className="split__label">{t('challenge')}</h2>
          <p className="prose">{project.challenge}</p>
        </div>
      </section>

      <section className="section">
        <div className="wrap split">
          <h2 className="split__label">{t('solution')}</h2>
          <p className="prose">{project.solution}</p>
        </div>
      </section>

      <section className="section">
        <div className="wrap split">
          <h2 className="split__label">{t('skills')}</h2>
          <ul className="rule-list">
            {project.skills.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default ProjectDetail;
